import { preview } from '@/components/form/preview'
import { Edit } from '@workwave-tidal/core/icons'
import { useTexts } from './hooks/useTexts'

interface Props {
  onEdit: () => void
}

export function DriverActivityHeader(props: Props) {
  const texts = useTexts()

  return (
    <preview.Header
      title={texts.headerTitle}
      subtitle={texts.headerDescription}
      testId="driver-activity-view-header"
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<Edit />}
          onClick={props.onEdit}
          label={texts.edit}
          disableWhenReadOnly
          tooltip={texts.edit}
          testId="driver-activity-view__edit"
          data-trackid="driver-activity-view__edit"
        />
      </preview.ActionBar>
    </preview.Header>
  )
}
